import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec2e61ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "team-container" }
const _hoisted_2 = { class: "left-container" }
const _hoisted_3 = {
  "data-wow-duration": "1s",
  class: "teamtitle animate__animated animate__fadeInDown wow"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))

import WOW from 'wowjs'
import { onMounted, ref } from "vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'AboutBanner',
  setup(__props) {

const isHover = ref(false)
onMounted(() => {
  new WOW.WOW(
    { live: false }
  ).init()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('stepinto')), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('steptext')), 1),
        _hoisted_4
      ])
    ])
  ]))
}
}

})